import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PageNotFoundComponent } from './navigation/page-not-found/page-not-found.component';
import { LandingPageComponent } from './navigation/landing-page/landing-page.component';
import { loginGuard } from './authentication/services/login.guard';
import { deactivateGuard } from './authentication/i-deactivate/i-deactivate.component';
import { AdminComponent } from './admin/components/admin/admin.component';
import { CommunityContainerComponent } from './project/component/community-project/community-container.component';
import { ResetPasswordComponent } from './authentication/reset-password/reset-password.component';
import { ForgetPasswordComponent } from './authentication/reset-password/forget-password/forget-password.component';
import { WorkspaceComponent } from './workspace/components/workspace/workspace.component';
import { VerifyComponent } from './authentication/verify/verify.component';
import { CmsPageComponent } from './shopware-cms/components/cms-page/cms-page.component';
import { ImgDbComponent } from './img-db/img-db.module';
import { ProjectSplitScreenComponent } from './project-split-screen/components/project-split-screen/project-split-screen.component';
import { UserAreaComponent } from './user-area/user-area.component';
import { ContainerOverviewComponent } from './workspace/components/container-overview/container-overview.component';
import { SIDEBAR_NAV_ROUTE_DATA } from './shared/models/sidebar-nav-route-data';
import { PrepaidSubscriptionComponent } from './xtra/prepaid-subscription/prepaid-subscription.component';
import { OrganizationAreaComponent } from './organization-area/organization-area.component';

const routes: Routes = [
    { path: 'home', component: LandingPageComponent },
    {
        path: 'profile',
        component: UserAreaComponent,
        canActivate: [loginGuard],
        canDeactivate: [deactivateGuard],
        data: { sidebarNav: SIDEBAR_NAV_ROUTE_DATA.PROFILE },
    },
    {
        path: 'organization',
        component: OrganizationAreaComponent,
        canActivate: [loginGuard],
        data: { sidebarNav: SIDEBAR_NAV_ROUTE_DATA.ORGANIZATION },
    },
    {
        path: 'admin',
        component: AdminComponent,
        canActivate: [loginGuard],
        canDeactivate: [deactivateGuard],
        data: { sidebarNav: SIDEBAR_NAV_ROUTE_DATA.ADMIN },
    },
    {
        path: 'project/:containerType/:containerId',
        component: ProjectSplitScreenComponent,
        canActivate: [loginGuard],
        data: {
            sidebarNav: SIDEBAR_NAV_ROUTE_DATA.PROJECT_BY_CONTAINER_TYPE,
        },
    },
    {
        path: 'communityprojects',
        component: CommunityContainerComponent,
        canActivate: [loginGuard],
        data: { sidebarNav: SIDEBAR_NAV_ROUTE_DATA.COMMUNITY_PROJECTS },
    },
    {
        path: 'workspace',
        component: WorkspaceComponent,
        canActivate: [loginGuard],
        data: { sidebarNav: SIDEBAR_NAV_ROUTE_DATA.WORKSPACE },
    },
    {
        path: 'workspace/:type',
        component: ContainerOverviewComponent,
        canActivate: [loginGuard],
        data: { sidebarNav: SIDEBAR_NAV_ROUTE_DATA.WORKSPACE_BY_TYPE },
    },
    {
        path: 'db/:containerType/:containerId',
        component: ImgDbComponent,
        canActivate: [loginGuard],
        data: { sidebarNav: SIDEBAR_NAV_ROUTE_DATA.DB_BY_CONTAINER_TYPE },
    },
    {
        path: 'prepaid-subscription/:subscriptionType',
        component: PrepaidSubscriptionComponent,
        canActivate: [loginGuard],
    },
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full',
    },
    { path: 'reset/password', component: ResetPasswordComponent },
    { path: 'verify', component: VerifyComponent },
    { path: 'forget/password', component: ForgetPasswordComponent },
    { path: 'Doku-Test', component: CmsPageComponent },
    { path: 'cms/:categoryId', component: CmsPageComponent },
    { path: '**', component: PageNotFoundComponent },
];

@NgModule({
    declarations: [],
    imports: [
        RouterModule.forRoot(routes, {
            /* scrollPositionRestoration: 'enabled', */
            onSameUrlNavigation: 'reload',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
